<template>
    <div >
        <div > 
            <form @submit.prevent="seuil_submit">
                <table class="table text-center font-weight-light table-borderless">
                     <tr>
                        <td style="text-align: left; font-weight: bold;">Nom de l'alarme:</td>
                    </tr>
                    <tr>
                        <td COLSPAN="3">
                         
                            <input type="text" id="name" class="form-control border-color not-allowed "  v-model="alarme.alarm_name"
                               @keypress="check_name($event)"
                                placeholder="Entrer le nom de l'alarme"  
                                minlength="1" 
                                maxlength="255" 
                                required
                                pattern="[a-zA-ZÀ-ÿ][a-zA-ZÀ-ÿ0-9 ]*"
                                title="Commencer par une lettre avec ou sans accent et entrer par la suite des lettres, chiffres ou espace"
                            >
                        </td>
                    </tr>
                    <tr>
                        <td style="text-align: left; font-weight: bold;">Destinataire :</td>
                    </tr>
                    <tr>
                        <td  COLSPAN="3">
                            <select v-model="alarme.dest_id" class="form-control" 
                                required>
                                <option disabled v-bind:value="null" selected>Choisissez le Destinataire</option>
                                <option v-for="group in adherents" v-bind:value="group.id" v-bind:key="group.id">
                                {{ group.fullname + ' '+ '('+ group.code + ')'}}
                                </option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td style="text-align: left; font-weight: bold;">Seuil :</td> 
                        <td style="text-align: left; font-weight: bold;">Type d'unité :</td> 
                        <td style="text-align: left; font-weight: bold;">Polarité :</td> 
                        
                    </tr>
                    <tr>
                    
                        <td class="align-middle">
                            <input type="text" id="seuil" class="form-control border-color not-allowed " v-model="alarme.seuil"
                                @keypress="check_input($event)"
                                placeholder="Entrer une valeur" 
                                required 
                                minlength="1" 
                                maxlength="10"
                                pattern="^(?=.*[1-9])[0-9]*$|[1-9][0-9]*|^([0-9]*)[1-9]$"
                                title= "Saisir un nombre entier different de 0"
                            >
                        </td>
                        <td >
                            
                            <select v-model="alarme.unit_type"  class="form-control " required >
                                <option disabled v-bind:value="null" selected>Choisissez un type d'unité</option>
                                
                                
                                <option value="1">{{ this.unit_t }} </option>
                                <option value="2"> temps d'utilisation/jours (h/jr) </option>
                            </select>
                        </td>
                         <td >
                            <select v-model="alarme.seuil_type"  class="form-control " required >
                                <option disabled v-bind:value="null" selected>Choisissez un type de seuil</option>
                                
                                <option value="1"> inférieur au seuil </option>
                                <option value="2"> supérieur au seuil </option>
                            </select>
                        </td>
                        
                    </tr>
                    <tr>
                        <td  class="align-middle" colspan="3">
                            <div  class="text-center mt-4" >
                                <b-button class="btn btn-default mr-3" :disabled="isBusy" @click="$emit('seuil-config-done',{'error' : true,})">Annuler</b-button>
                                <!--<b-button class="btn btn-default mr-3" variant="secondary" :disabled="isBusy" @click="annuler()"> Annuler </b-button>-->
                                <b-button  type="submit" class="btn btn-primary"> Valider </b-button>
                            </div>
                            <div class="alert alert-danger" role="alert" v-if="error">
                                Impossible d'ajouter une alarme seuil ! Veuillez contacter KEMTAG
                                <i class="ti-close float-right mt-1" @click="error = false"></i>
                            </div> 
                        </td>
                    </tr>
                
                </table>
            </form>
        </div>
    </div>
</template>

<script>
import api from "../../config/_api";
import { mapGetters } from 'vuex';
export default {
     
    name :"SeuilConfig",
    data () {
        return {
            unit: null,
            unit_t: null,
			isBusy: false,  
            error: false, // initialiser l'objet error {pour la fonction alerte}     
            stateForm :0 ,
            initialName: null,
            initialDest: 0,
            initialSeuil: 0,
            initialUnit_type: 0,
            initialSeuil_type: 0,
             alarme:{
                id :0,
                alarm_name: null,
                unit_type: null,
                dest_id: null,
                seuil: null,
                seuil_type: null,
            }
        }
    },
    props :{
        selected_system: {
            type: Object,
            required: false
        },
        seuil_alarm : {
            type: Object,
            required: false
        },
        action : ""
    },
    computed :{
         ...mapGetters({
               adherents: 'adherents/adherents',
                  
            }),
    },
    mounted (){
        
        this.$store.dispatch('adherents/getAdherents');
        //this.unit_t= this.unite();
        //this.unit_t;
        //recupération des données initiales si l'alarme existe déjà

        if (this.seuil_alarm) {
            this.alarme.id = this.seuil_alarm.id;
            this.alarme.alarm_name = this.seuil_alarm.alarm_name;
            this.alarme.unit_type = this.seuil_alarm.unit_type;
            this.alarme.seuil = this.seuil_alarm.seuil;
            this.alarme.dest_id = this.seuil_alarm.dest_id;
            this.alarme.seuil_type = this.seuil_alarm.seuil_type;
            

            //on recupère les valeurs du popup systemAlert pour confirmer annuler modif
            /*this.initialName= this.alarme.nom;
            this.initialUnit_type= this.alarme.unit_type;
            this.initialDest= this.alarme.dest;
            this.initialSeuil= this.alarme.seuil;
            this.initialSeuil_type= this.alarme.seuil_type;*/
        }
        
    },
    created(){
        this.unite();
        this.setValues();
    },


    methods : {
        //demande de confirmation
         /*annuler (){
            this.seuil = document.getElementById("seuil").value;
            this.alarm_name = document.getElementById("name").value;
             if((this.alarme.dest!=this.initialDest)||(this.alarme.unit_type!=this.initialUnit_type)||(this.alarme.seuil_type!=this.initialSeuil_type)||( this.seuil!=this.initialSeuil)||(this.alarm_name!=this.initialName)){

                //console.log('La valeur du sélecteur  a changé !');
                this.$bvModal.msgBoxConfirm('Êtes-vous certain de vouloir annuler les modifications ?', {
					title: 'Annuler les modifications',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'danger',
					okTitle: 'Confirmer',
					cancelTitle: 'Annuler',
					footerClass: 'p-2',
					hideHeaderClose: false,
                    centered: true,
                    
				}).then(value => {
					if(value) {
                      this.$emit('seuil-config-done')
                    }
                    
				})
            }
            else{
                this.$emit('seuil-config-done')
            }
            
        },*/
        unite(){
             if(this.selected_system!=null){
                 
                 var unit_t = null;
                //this.unit = this.selected_system.status;
                this.$store.dispatch('display_unit/getUnit', {
						id: this._props.selected_system.display_unit_id,
                        
				}).then(resp => {
                    const unit = resp.title;
                    this.setValues(unit);
                
									
				}).catch((error) => {
					this.error = true; 
                    //console.log(err);
                                
                })
                // condition pour mettre à jour unit_type en fonction des differents unit(0 à 6) et l'utiliser comme vmodel de la permière option
                
                    /*unit = resp.title;	
                    
                return	unit_t;*/
                
                
            }
        },
        setValues(unit){
            if(unit=='0'){
                this.unit_t= 'unités/heure';
            }	
            else if(unit=='1'){
                this.unit_t= 'hectares/heure';
            }	
            else if(unit=='2'){
                this.unit_t= 'kilomètres/heure';
            }	
             else if(unit=='3'){
                this.unit_t= 'contacts/heure';
            }
            
             else if(unit=='4'){
                this.unit_t= 'heures/heure';
            }	
             else if(unit=='5'){
                this.unit_t= 'Kwh/heure';
            }
             else if(unit=='6'){
                this.unit_t= 'm³/heure';
            }	
            
        },

        seuil_submit() {
            let data = {
                //seuil: document.getElementById("seuil").value,
                seuil: this.alarme.seuil,
                dest_id: this.alarme.dest_id,
                unit_type:this.alarme.unit_type,
                seuil_type:this.alarme.seuil_type,
            };
            //this.seuil = document.getElementById("seuil").value;
            this.seuil= this.alarme.seuil;
            this.alarm_name = document.getElementById("name").value;
           
            this.dest_id= this.alarme.dest_id;
            //faire un update avec le module
                if(this.alarme.id!=0){
                    this.$store.dispatch('system_alarm_seuil/update', {
								id: this.alarme.id,
                                unit_type: this.alarme.unit_type,
                                seuil_type: this.alarme.seuil_type,
								dest_id: this.dest_id,
								seuil: this.seuil,
								alarm_name: this.alarm_name
					}).then(resp => {
								this.$emit('seuil-config-done',{'error' : false,'resp' : resp});
								
								
							}).catch((error) => {
					        	this.error = true; 
                                //console.log(err);
                                
					        })

                }
                else {
                     this.$store.dispatch('system_alarm_seuil/create', {
								system_id: this._props.selected_system.id,
                                unit_type: this.alarme.unit_type,
                                seuil_type: this.alarme.seuil_type,
								dest_id: this.dest_id,
								seuil: this.seuil,
								alarm_name: this.alarm_name
					}).then(resp => {
								this.$emit('seuil-config-done',{'error' : false,'resp' : resp});
	
							}).catch((error) => {
					        	this.error = true; 
    
					        })
                }

                
        },

        //empêche la saisie de 0 comme 1er chiffre et n'autorise pas une valeur >  4 294 967 295 ( 2 exp 32-1)
        check_input: function(event){
            var input = event.target;
            
            var value = parseInt(input.value + event.key);
           
            if (isNaN(value) || value >  4294967295) {
                event.preventDefault();
            } 
             else if (input.value === "" && event.key === "0") {
                event.preventDefault();
             }
            //else if (input.value === "" || input.value !== "0") {
            else if (input.value === "" || input.value !== "0" || input.value == "0") {
                if( event.keyCode < 48 ||  event.keyCode > 57 ) event.returnValue = false;
                if( event.which < 48 ||  event.which > 57  ) return false;
            } 
           
            else {
                event.preventDefault();
            }
        },
        check_name(event) {
            var input = event.target;
            var value = input.value + event.key;
            var hasLetter =/[a-zA-ZÀ-ÿ]/.test(input.value); // Vérifie s'il y a au moins une lettre dans le champ
            var haschiffre = /[0-9]/.test(input.value); // Vérifie s'il y a au moins un chiffre dans le champ

            if ((hasLetter)||(!hasLetter && haschiffre)) {
                // Si au moins une lettre est déjà saisie, autoriser la saisie de lettres et de chiffres et d'espaces
               
                if (/^[a-zA-ZÀ-ÿ0-9\s]*$/.test(value)) {
                return true;
                }
            } else {
                // Si aucune lettre n'est saisie, empêcher la saisie de chiffres
                if (/^[a-zA-ZÀ-ÿ]*$/.test(value)) {
                return true;
                }
            }

            event.preventDefault();
        },
    }
}

</script>
